import React from 'react';
import {Breadcrumbs as MuiBreadcrumbs, Link, Typography} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {UIMatch, useMatches, useNavigate} from 'react-router-dom';
import {useDynamicCrumbLabel} from '@/context/BreadcrumbContext';

interface Crumb {
    text: string;
    href: string;
}

const HeaderBreadcrumbs: React.FC = () => {
    const matches = useMatches();
    const navigate = useNavigate();
    const dynamicLabel = useDynamicCrumbLabel();

    const crumbs: Crumb[] = matches
        .filter((match: UIMatch<any, any>) => Boolean(match.handle?.crumb))
        .map((match: UIMatch<any, any>) => ({
            text:
                match.handle.crumb instanceof Function
                    ? match.handle.crumb(match.data)
                    : match.handle.crumb,
            href: match.pathname,
        }));

    if (crumbs.length === 0) return null;

    // A detail page can supply a runtime name (e.g. a dashboard name) for the
    // current (last) crumb, replacing its static route label.
    if (dynamicLabel) {
        crumbs[crumbs.length - 1] = {...crumbs[crumbs.length - 1], text: dynamicLabel};
    }

    return (
        <MuiBreadcrumbs
            separator={<NavigateNextIcon fontSize="small"/>}
            aria-label="breadcrumb"
            className="header-breadcrumbs"
            sx={{
                color: 'rgba(255, 255, 255, 0.85)',
                '& .MuiBreadcrumbs-separator': {color: 'rgba(255, 255, 255, 0.6)'},
            }}
        >
            {crumbs.map((crumb, index) => {
                const isLast = index === crumbs.length - 1;
                if (isLast) {
                    return (
                        <Typography key={crumb.href} sx={{color: '#fff', fontWeight: 500}}>
                            {crumb.text}
                        </Typography>
                    );
                }
                return (
                    <Link
                        key={crumb.href}
                        component="button"
                        underline="hover"
                        onClick={() => navigate(crumb.href)}
                        sx={{color: 'inherit', cursor: 'pointer', font: 'inherit'}}
                    >
                        {crumb.text}
                    </Link>
                );
            })}
        </MuiBreadcrumbs>
    );
};

export default HeaderBreadcrumbs;
